import { Code, ConnectError } from '@connectrpc/connect';
import { createConnectTransport } from '@connectrpc/connect-web';
import { useAuthStore } from '../store/authStore';
const authInterceptor = (next)=>async (req)=>{
        const token = useAuthStore.getState().token;
        if (token) {
            req.header.set('Authorization', `Bearer ${token}`);
        }
        try {
            return await next(req);
        } catch (err) {
            if (err instanceof ConnectError && err.code === Code.Unauthenticated) {
                useAuthStore.getState().logout();
                window.location.href = '/login';
            }
            throw err;
        }
    };
export const transport = createConnectTransport({
    baseUrl: '/',
    interceptors: [
        authInterceptor
    ]
});
